<template>
  <div class="popup" v-show="copyToShow" v-cloak>
    <div id="CopyTo" class="content">
      <div class="title">
        <span>{{$t('language.common.copyTo')}}</span>
        <div class="icon white-close dialog-close" @click="closeTreeDialog()"></div>
      </div>
      <div class="task-content" v-loading='loading' ref="copyTree">
        <el-scrollbar style="height:100%;" ref="elscrollbar">
          <div v-if="!model.length&&!loading" class="nondrive-des" @click="toAddCloudPage()">
            {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
          </div>
          <div class="tree-nodes">
            <ul :key=index v-for="(item,index) in model">
              <tree ref="tree" :model="item" :index=index :treeShow=true transferAimFlag="CopyTo"></tree>
            </ul>
          </div>
        </el-scrollbar>
      </div>
      <div class="task-footer">
        <div class="icon-util nocheck move-position" :class="[$store.state.multiSelect==true?'check':'']"
          @click="multi($event)"></div>
        <div class="multi-select">{{$t('language.common.multiSelect')}}</div>
        <div class="multi-select email-options" v-if="isEmails">
          <div class="icon-util setting"></div>
          <div style="margin: 0 5px 0 5px">{{$t('language.common.options')}}</div>
          <div class="icon-util drop-down"></div>
          <div class="email-options-items">
            <div class="email-paste-option">
                <div class="icon-util" :class="options.isSaveAtt?'check-small':'nocheck-small-blue'" @click="options.isSaveAtt=!options.isSaveAtt"></div>
                <div>{{$t('language.emailTransfer.saveAtt')}}</div>
            </div>
            <div class="email-paste-option">
                <div class="icon-util" :class="options.isConver?'check-small':'nocheck-small-blue'" @click="options.isConver=!options.isConver"></div>
                <div>{{$t('language.emailTransfer.converFormat')}}</div>
                <div class="icon-util question-mark">
                    <div class="plan-questionTxt">{{$t('language.emailTransfer.converFormatTip')}}</div>
                </div>
            </div>
            <div class="email-paste-option">
                <div class="icon-util" :class="options.isSaveOnly?'check-small':'nocheck-small-blue'" @click="options.isSaveOnly=!options.isSaveOnly"></div>
                <div>{{$t('language.emailTransfer.saveOnly')}}</div>
            </div>
          </div>
        </div>
        <button class="task-button" @click="startCopyTo()">{{$t('language.common.ok')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import commonstate from '@/js/constant.js';
  import commonUtils from "@/js/workspace/common_util.js";
  import tree from '@/components/common/trees/tree';
  import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
  import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
  import Utils from '@/js/request_util';
  export default {
    components: {
      tree,
    },
    data: function() {
      return {
        copyToShow: false,
        model: [],
        sourceIndex: -1,
        aimIndex: -1,
        tid: null,
        judgeFlag: false,
        dataArr: [],
        aimItems: [],
        loading: false,
        shareDataArr: [], //share用
        teamDataArr: [], //team用
        isEmails: false,//邮件管理页面用
        options: {
          isSaveAtt: true,
          isConver: true,
          isSaveOnly: false,
        }
      }
    },
    inject: ["reload"],
    mounted() {
      this.$store.commit('setClickItem', null);
      this.$store.state.arr = [];
    },
    created() {
      this.initData();
    },
    methods: {
      toAddCloudPage() {
        let dom;
        let that = this;
        $.each(that.$parent.$parent.$children, function(i, item) {
          if (item.menuOptions) {
            dom = that.$parent.$parent.$children[i];
            dom.menuOptionSelect(10);
            return;
          }
        });
      },
      //初始化copy to界面数据
      initData() {
        let that = this;
        this.loading = true;
        this.options={
          isSaveAtt: true,
          isConver: true,
          isSaveOnly: false,
        };
        //数据为缓存中的UsersDrives
        this.model = Object.assign([], this.$store.getters.getUsersDrives);
        //如果缓存中没有数据，并且该界面为云盘管理界面，则向后端初始化数据
        if (!this.model.length && (that.$route.name == 'cloudExploer' || that.$route.name == 'emailExploer')) {
          this.model = this.Utils.getAllCloudsList(function(res) {
            if (res.status == 200) {
              that.loading = false;
            }
          });
        } else {
          this.loading = false;
        }
        //copy不支持到邮件
        this.model = this.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType) );
        //将数据设置为关闭
        $.each(this.model, function(index, item) {
          item.open = false;
        });

      },
      //用户执行剪切操作
      move(event) {
        let dom = event.currentTarget;
        //取消选中剪切
        if (this.$store.state.treeMoveSelect == true) {
          this.$store.commit('setTreeMoveSelect', false);
          this.$store.commit('setClickItem', -1);
        } else {
          //默认选中剪切
          this.$store.commit('setMultiSelect', false);
          this.$store.commit('setTreeMoveSelect', true);
        }
      },
      //用户执行多选的复制操作
      multi(event) {
        let dom = event.currentTarget;
        if (this.$store.state.multiSelect == true) {
          this.$store.commit('setMultiSelect', false);
          this.$store.state.arr = [];
        } else {
          this.$store.commit('setMultiSelect', true);
          this.$store.commit('setTreeMoveSelect', false);
        }
      },
      //关闭树形组件
      closeTreeDialog() {
        $.each(this.model, function(index, item) {
          item.open = false;
          if (item.children && item.children.length) {
            commonUtils.closeTree(item.children);
          }
        });
        this.$store.commit('setClickItem', -1);
        this.$store.commit('setMultiSelect', false);
        this.$store.commit('setTreeMoveSelect', false);
        this.$store.commit('setClickItem', null);
        this.$store.state.arr = [];
        this.model = [];
        this.$refs.copyTree.scrollTop = 0;
        this.copyToShow = false;
        this.isEmails = false;
      },
      //开始进行Copy to传输数据
      startCopyTo() {
        //判断是否是临时用户，然后提醒用户进行绑定邮箱
        let user = commonUtils.getUser();
        if (commonUtils.testUserIsTourist(user)) {
          this.$parent.$refs.remindBindEmailDialog.remindBindEmailShow = true;
          this.$parent.$refs.remindBindEmailDialog.fromSign = 1;
          return false;
        }
        let dataArr;
        this.sourceIndex = -1;
        this.aimIndex = -1;
        this.judgeFlag = false;
        if (this.$route.name != 'preview') { //如果不是预览界面
          if ("Shares" === this.$parent.selectItemArr[0].driveType) {
            dataArr = Object.assign([], this.shareDataArr);
          } else if ("team" === this.$parent.selectItemArr[0].driveType) {
            dataArr = Object.assign([], this.teamDataArr);
          } else { //给dataArr赋值
            dataArr = Object.assign([], this.$parent.selectItemArr);
          }
        } else { //如果是预览界面，给dataArr赋值
          dataArr = this.$store.state.previewData;
        }
        //目标目录数据
        let aimItems = this.$store.state.arr;
        this.$parent.$refs.fileExistDialog.storeData = aimItems;
        this.dataArr = dataArr;
        this.aimItems = aimItems;
        if (aimItems.length) { //如果数据大于200条则进行弹窗提醒
          if ((this.$store.state.retryItems.length + dataArr.length) > 200) {
            let index = (this.$store.state.retryItems.length + dataArr.length) - 200;
            dataArr.splice(dataArr.length - index, dataArr.length + 1);
            this.$toast({
              text: this.$t('language.cloudExploer.simultaneous'),
              type: 'fail',
              idValue: "rightBo"
            });
          }
          this.copyToExeCute(dataArr, aimItems); //执行copy to操作
          this.closeTreeDialog(); //关闭界面
        } else {
          this.$toast({
            text: this.$t('language.common.selectNull'),
            type: 'fail',
            idValue: "rightBo"
          });
          return false;
        }
      },
      copyToExeCute(dataArr, aimItems) {
        let cutData;
        let options;
        let operate; //用于标识用户是复制还是剪切操作
        let that = this;
        let trSourceItem;
        let trAimItem;
        let allNameArr = [];
        var map = {};
        let user = JSON.parse(localStorage.getItem("user"));
        that.$store.state.cancelAllFlag = false;
        //流量不足弹窗提醒
        let usedTraffic = user.usedBytes;
        // if (user.vip && user.payLevel > 1) {
        //   usedTraffic = user.payUsedTraffic;
        // }
        if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
          this.$parent.$refs.upgradeDialog.upgradeShow = true;
          this.$parent.$refs.upgradeDialog.reset();
          this.$parent.$refs.upgradeDialog.trafficShow = true;
          return false;
        }
        //如果是邮件管理页面的copyTo
        if(this.isEmails){
          options = {
              attachment: this.options.isSaveAtt,
              conversationQuoted: this.options.isConver,
              onlyLastMail: this.options.isSaveOnly,
              replace: 4,
              way: 'cloudEmail',
          };
        }
        //遍历目标文件夹
        for (let k = 0; k < aimItems.length; k++) {
          let AimItem;
          let nameArr = [];
          let aimDriveId;
          let aimId;
          if (aimItems[k].appName) {
            aimDriveId = aimItems[k].id;
            aimId = aimItems[k].rootId;
          } else {
            aimDriveId = aimItems[k].driveId;
            aimId = aimItems[k].id;
          }
          let listData = new cloudExploerUtils.listData(aimId, user.id, aimDriveId);
          //该目标文件夹下所有的文件夹名称存入数据，以便判断能否重明名
          that.Utils.doFilesRequest("list", listData).then(res => {
            if (res.status == 200) {
              if (res.items.length) {
                for (let i = 0; i < res.items.length; i++) {
                  nameArr.push(res.items[i].name);
                  allNameArr.push(res.items[i].name);
                }
                map[aimItems[k].driveId] = nameArr;
              }
              //遍历出所有的目标文件名称
              if (k == aimItems.length - 1) {
                $.each(dataArr, function(index, sourceItem) {
                  let sourceToAimArr = map[sourceItem.driveId]; //获取该云盘id下的同名文件
                  //若是同名文件则弹窗 1.若两个云盘类型不相同，但全部名称含有同名则弹窗  2.若是两个云盘类型相同，却是不支持复制的云盘，且含有相同文件则弹窗
                  if (((!sourceToAimArr || !sourceToAimArr.length) && allNameArr.includes(sourceItem.name)) || (
                      commonstate.notSupportCopy.includes(sourceItem.driveType) && sourceToAimArr &&
                      sourceToAimArr.length && sourceToAimArr.includes(sourceItem.name))) {
                    that.$parent.$refs.fileExistDialog.fileExistShow = true;
                    that.$store.state.copyArr = []; //若出现了同名任务弹窗则清除选择的copy数据
                    if (that.$route.name != 'preview') { //如果是preview界面，临时任务弹窗不显示
                      that.$store.state.snapTaskShow = false;
                    }
                    that.copyToShow = false;
                    that.isEmails = false;
                    return false;
                  }
                  if (index == dataArr.length - 1) { //所选择的源文件结束时
                    trSourceItem = taskTransferUtils.createTransferFromItems(dataArr); //源封装数据
                    trAimItem = taskTransferUtils.createTransferFromItems(aimItems); //封装目标数据
                    commonUtils.judgeNewDataFlag(that); //判断新数据标志
                    //若是跨云盘的传输
                    var businessAddFlag = false;
                    var wasabiAddFlag = false;
                    if (trSourceItem[0].driveType == trAimItem[0].driveType) {
                      if ((trAimItem[0].driveType == 'gSuite' || trAimItem[0].driveType == 'boxBusiness' ||
                          trAimItem[0].driveType == 'oneDrive4Business') && trAimItem[0].fileId.indexOf(":") !=
                        -1) {
                        var args1 = trAimItem[0].fileId.split(":");
                        var userEmailId1 = args1[0];
                        var args2 = trSourceItem[0].fileId.split(":");
                        var userEmailId2 = args2[0];
                        if (userEmailId1 != userEmailId2) {
                          businessAddFlag = true;
                        }
                      }
                      if (trAimItem[0].driveType == 'dropbox4Business' && trAimItem[0].fileId.indexOf(":") != -
                        1) {
                        var args1 = trAimItem[0].fileId.split(":");
                        if (args1[2]) {
                          var userEmailId1 = args1[2];
                          var args2 = trSourceItem[0].fileId.split(":");
                          var userEmailId2 = args2[2];
                          if (userEmailId1 != userEmailId2) {
                            businessAddFlag = true;
                          }
                        }
                      }
                      //wasabi是不同桶之间复制则令wasabiAddFlag为true
                      if (trSourceItem[0].driveType == 'wasabi' || trSourceItem[0].driveType == 'iDrivee2') {
                        var args1 = trSourceItem[0].fileId.split("/");
                        var forBucketName = args1[0];
                        var args2 = trAimItem[0].fileId.split("/");
                        var toBucketName = args2[0];
                        if (forBucketName != toBucketName) {
                          wasabiAddFlag = true;
                        }
                      }
                    }
                    if (((trSourceItem[0].driveType == trAimItem[0].driveType) && commonstate.notSupportCopy
                        .includes(trAimItem[0].driveType)) || trSourceItem[0].driveId != trAimItem[0].driveId ||
                      trSourceItem[0].permissionId != trAimItem[0].permissionId || businessAddFlag || wasabiAddFlag) {
                      commonUtils.packageDetailData(trSourceItem, trAimItem, false); //将数据放入临时任务和临时任务界面弹窗
                      that.$parent.snapTaskIconShow = true;
                      that.$store.state.snapTaskShow = true; //显示临时任务弹窗
                      let addData = new taskTransferUtils.addTaskData(user.id, 4, trSourceItem[trSourceItem
                        .length - 1].filename, trSourceItem, trAimItem, options, null);
                      that.Utils.doTasksRequest('add', addData).then(res => {
                        that.$store.state.cancelAllFlag = true; //取消标志设为真
                        if (res.status == 200) {
                          commonUtils.letFlagTrue(that); //让标志设为真
                          commonUtils.packageHaveDataDetail(res.tasks); //给前端加入的假数据赋值id
                        } else if (res.status == 400 && res.reason == 'permissionFail') {
                          commonUtils.removeDataDetail(addData);
                          that.$parent.reFresh();
                          that.$toast({
                            text: that.$t('language.exception.notPermission'),
                            type: 'fail',
                            idValue: "rightBo",
                            duration: 5000
                          });
                        } else if (res.status == 400 && res.reason == 'notEnoughTimes'){
                          commonUtils.removeDataDetail(addData);
                          that.$parent.reFresh();
                          //弹出付费弹窗
                          that.$parent.$refs.upgradeDialog.upgradeShow = true;
                          that.$parent.$refs.upgradeDialog.reset();
                          that.$parent.$refs.upgradeDialog.emailShow = true;
                          that.closeTreeDialog()
                          return false;
                        }
                      });
                    } else {
                      //如果是同云盘的数据，弹窗和全部取消标志设为真
                      that.$parent.snapTaskIconShow = true;
                      that.$store.state.snapTaskShow = true;
                      that.$store.state.cancelAllFlag = true;
                      commonUtils.judgeNewDataFlag(that);
                      commonUtils.letFlagTrue(that);
                      $.each(trSourceItem, function(index1, Item) {
                        $.each(trAimItem, function(aimIndex, aimItem) {
                          //如果是同云盘的数据
                          if (that.$store.state.treeMoveSelect) {
                            options = { //如果是剪切状态
                              isRemove: 1,
                              isChar: 1
                            }
                            operate = 'cut'; //如果是剪切状态
                          } else { //如果是复制状态
                            options = {
                              isRemove: 0,
                              isChar: 1
                            }
                            operate = 'copy';
                          }
                          cutData = new cloudExploerUtils.movePasteData(JSON.parse(localStorage.getItem(
                              "user")).id, Item.driveId, Item.pid, Item.fileId, aimItem.fileId, Item
                            .filename, null, Item.isDir);
                          that.$store.state.retryItems.push({ //把值加入临时任务等待列表
                            name: Item.filename,
                            status: 'ready',
                            cutData: cutData,
                            operate: operate,
                            toDriveType: Item.driveType,
                            aimPid: Item.pid,
                            sharePath: Item.sharePath,
                            shareUrl: Item.shareUrl
                          });
                        });
                      });
                    }
                    if (that.$route.name == 'preview') { //如果是预览界面则跳转到上一页
                      history.go(-1);
                    }
                  }
                });
              }
            }
          });
        }
      },
    }
  }
</script>

<style>
  #CopyTo {
    width: 500px;
    /*no*/
    height: 500px;
    /*no*/
  }

  #CopyTo ul {
    list-style: none;
    color: #6f7886;
    margin: 0;
    padding-left: 15px;
    /*no*/
    display: block;
    list-style-type: disc;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  #CopyTo li {
    list-style: none;
    min-width: 400px;
    /*no*/
    text-align: left;
    white-space: nowrap;
    margin: 0;
  }

  #CopyTo .tree-node-div {
    word-break: keep-all;
    white-space: nowrap;
    min-width: 460px;
    /*no*/
    height: 40px;
    /*no*/
    overflow: hidden;
  }

  #CopyTo .email-options {
    display: flex;
    align-items: center;
    margin-left: 20px;/*no*/
    cursor: pointer;
  }

  #CopyTo .email-options-items {
    text-align: left;
    display: none;
    position: absolute;
    border: 1Px solid #5562b4;/*no*/
    border-radius: 3Px;/*no*/
    padding: 10px 20px;/*no*/
    background: #ffffff;
    top: 35px;/*no*/
  }

  #CopyTo .email-options:hover .email-options-items{
    display: unset;
  }

  #CopyTo .email-paste-option {
    display: flex;
    line-height: 20px;/*no*/
    white-space: nowrap;
  }

  #CopyTo .email-paste-option .icon-util {
    margin-top: 3px;/*no*/
    margin-right: 10px;/*no*/
    cursor: pointer;
  }

  #CopyTo .question-mark{
    margin-top: 0 !important;
    position: relative;
  }

  #CopyTo .question-mark:hover .plan-questionTxt {
    display: block;
  }

  #CopyTo .plan-questionTxt {
    text-align: left;
    display: none;
    position: absolute;
    width: 255Px;/*no*/
    border: 1Px solid #5562b4;/*no*/
    border-radius: 3Px;/*no*/
    left: 10Px !important;/*no*/
    top: 18Px !important;/*no*/
    background: #fff;
    z-index: 3;
    font-size: 12Px;/*no*/
    box-sizing: border-box;
    padding: 5Px;/*no*/
    line-height: 20Px;/*no*/
    color: #333333;
    white-space: break-spaces;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/copy_to_popup.vue